<template>
    <div class="wrap-content ocr-config-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-4">
                    <h2>Customer On Boarding</h2>
                </div>
            </div>
        </div>

        <div class="config-card-switch">
            <div class="row">
                <div v-if="!showPageLoader" class="col-lg-12">
                    <div class="card custom-card">
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">
                                    OCR Switch
                                </h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            id="populatedata"
                                            label="Use OCR to populate Data in Registration Form"
                                            label-for="populatedata"
                                        >
                                            <b-form-radio-group
                                                v-model="formData.switch"
                                                :options="ocrSwitch"
                                                name="switch"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">
                                    ID Document Number
                                </h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group
                                            label="Restrict duplicate ID document numbers"
                                            label-for="restrict-duplicate-customers"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData.restrictDuplicateCustomers
                                                "
                                                :options="documentOptions"
                                                name="radio-options"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <b-button
                                    type="submit"
                                    variant="primary"
                                    :class="loading ? 'disabled' : ''"
                                    @click.prevent="
                                        updateOnboardingConfiguration()
                                    "
                                >
                                    <span class="btn-text">UPDATE</span>
                                    <span class="loader"></span>
                                </b-button>
                                <base-toast></base-toast>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- When data is loading -->
                <base-table-spinner v-if="showPageLoader"></base-table-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const viewOcrResource = new resource('configurations/ocr')
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showPageLoader: true,
            query: {
                dataSegmentId: localStorage.getItem('dataSegmentId'),
            },
            formData: {
                // switch: false,
                // restrictDuplicateCustomers: false,
            },
            ocrSwitch: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            documentOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            ocrList: [],
            resourceApi: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading', 'data']),
    }, // End of Component > mounted

    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getOcrData()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getOcrData()
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getOcrData() {
            if (this.dataSegmentId) {
                this.query.dataSegmentId = this.dataSegmentId
            }
            let { data } = await viewOcrResource.list(this.query)
            this.formData = data.data
            this.showPageLoader = false
        },

        async updateOnboardingConfiguration() {
            try {
                // update on boarding configuration
                this.$store.commit('setLoading', true)
                let { data } = await viewOcrResource.update(
                    this.formData._id,
                    this.formData
                )
                await viewOcrResource.list(this.query)
                this.$store.commit('setLoading', false)
                this.$store.commit('setSuccess', data.message)
            } catch (error) {
                this.$store.commit(
                    'setError',
                    'There is an error update on boarding configuration'
                )

                // console.log(
                //     error,
                //     'There is an error update on boarding configuration'
                // )
            }
        },
    },
} // End of export default
</script>
